import {logIfDebug} from "../global/logFunctions";
import {isUVCoordinateInFaceUV} from "./isUVCoordinateInFaceUV";
import {THREE} from "./resource/BVH";

export function getObject3DCoordinateOfUV(mesh:THREE.Mesh, coordinateUV:{x:number, y:number}, withApplyedObjectMatrix:boolean):{isUVInFace:boolean, coordinateOnObject:THREE.Vector3} {
    const result = {isUVInFace: false, coordinateOnObject: new THREE.Vector3(0.0)};
    let tmpResult: { isUVInFace: any; coordinateOnObject: any; };

    // Error wenn keine UV übergeben wurde
    if (!coordinateUV) {
        //FIXME hier wird aber trotzdem weitergemacht??
        logIfDebug('no UV coordinate');
    }

    // Set Default Value
    withApplyedObjectMatrix = withApplyedObjectMatrix || false;

    const geometry = mesh.geometry;

    if (!(geometry instanceof THREE.BufferGeometry)) {
        console.error('error in getObject3DCoordinateOfUV: Geometry-Type not yet supported');
        return result;
    }


    const attributes = geometry.attributes;
    //positions = attributes.position.array;

    if (geometry.index) {
        tmpResult = getISUVCoordinateInFaceUVFromIndexedGeometry(mesh, coordinateUV);

    } else {
        for (let i = 0, il = attributes.position.array.length / 9; i < il; i += 1) {
            tmpResult = isUVCoordinateInFaceUV(mesh, i, coordinateUV);
            if (tmpResult.isUVInFace) {
                break;
            }
        }
    }
    if (!tmpResult.isUVInFace) {
        // Was machen wir wenn die UV-Koordinate nicht auf dem Object liegt?
        // Sie liegt ausserhalb des Objects ... Mapping auf nähesten Punkt=
        //tmpResult = ;
    }
    result.isUVInFace = tmpResult.isUVInFace;
    if (tmpResult.isUVInFace) {
        result.coordinateOnObject.set(tmpResult.coordinateOnObject.x, tmpResult.coordinateOnObject.y, tmpResult.coordinateOnObject.z);
        if (withApplyedObjectMatrix) {
            result.coordinateOnObject.applyMatrix4((mesh as THREE.Mesh).matrixWorld);
        }
    }
    return result;
}

function getISUVCoordinateInFaceUVFromIndexedGeometry(mesh:THREE.Mesh, coordinateUV:{x:number, y:number}) {
    let tmpResult:{isUVInFace: false;coordinateOnObject: { x:number; y:number; z:number }};
    const indices = mesh.geometry.index.array;
    let groups = mesh.geometry.groups;

    if (groups.length === 0) {
        groups = [{start: 0, count: indices.length, index: 0}];
    }

    for (let groupCounter = 0, groupsLength = groups.length; groupCounter < groupsLength; ++groupCounter) {
        tmpResult = groupIsInFaceUV(mesh, groups[groupCounter].start, groups[groupCounter].count, coordinateUV);
        if (tmpResult.isUVInFace) {
            return tmpResult;
        }
    }
    return tmpResult;
}

function groupIsInFaceUV(mesh:THREE.Mesh, start:number, count:number, coordinateUV:{x:number, y:number}) {
    let tmpResult:{isUVInFace: false;coordinateOnObject: { x:number; y:number; z:number }};
    for (let faceIndex = start, il = (start + count) / 3; faceIndex < il; faceIndex += 1) {
        tmpResult = isUVCoordinateInFaceUV(mesh, faceIndex, coordinateUV);
        if (tmpResult.isUVInFace) {
            return tmpResult;
        }
    }
    return tmpResult;
}
